<template>
  <div>


    <div style="margin: 0;padding: 0">
      <el-carousel height="65vh" :interval="4000">
        <el-carousel-item v-for="item in urls" :key="item">
          <el-image style="width: 100%; height: 65vh" :src="item" :fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <span v-if="lan=='zh'" v-html="infoZH"> </span>
    <span v-else v-html="infoEN"></span>

    <div style="margin-bottom: 5vh;display:none">
      <el-row class="myrow">
        <el-col :span="9" :offset="3">

          <div style="margin-right: 3vw">

            <el-image :src="require('@/assets/img/mo_03.png')"
                       style="margin-bottom:2vh;background-color:white;padding:5px;height: 5vw"></el-image>

            <div class="homeBigText">
              <div v-if="result.rows.length>0">
                <span v-if="lan=='zh'" > {{result.rows[0].title}}</span>
                <span v-else>{{result.rows[0].titleEn}}</span>
              </div>
              <div v-else>
                {{ $t("home.home11") }}
              </div>
            </div>
            <div class="homeNormalText">
              <span v-if="result.rows.length>0">
                <p v-if="lan=='zh'" v-html="result.rows[0].content" ></p>
                <p v-else  v-html="result.rows[0].contentEn"> </p>
              </span>
              <p v-else>
                {{ $t("home.home12") }}
              </p>
            </div>
            <!--            <el-link class="homeMoreText" type="danger">{{ $t("home.homeMore") }}</el-link>-->
          </div>

        </el-col>
        <el-col :span="9">
          <div  v-if="result.rows.length>0" >

            <el-image class="homeImage" :src="imgWeb+result.rows[0].url" :fit="imgFit"></el-image>
          </div>
          <div v-else>
            <el-image class="homeImage" :src="require('@/assets/img/home1.jpg')" :fit="imgFit"></el-image>
          </div>

        </el-col>
      </el-row>
      <el-row class="myrow">
        <el-col :span="9" :offset="3">
          <div  v-if="result.rows.length>1" >
            <el-image class="homeImage" :src="imgWeb+result.rows[1].url" :fit="imgFit"></el-image>
          </div>
          <div v-else>
            <el-image class="homeImage" :src="require('@/assets/img/home2.jpg')" :fit="imgFit"></el-image>
          </div>
        </el-col>
        <el-col :span="9">
          <div style="margin-left: 3vw">
            <el-image :src="require('@/assets/img/mo_02.png')"
                      style="margin-bottom:2vh;background-color:white;padding:5px;height: 5vw"></el-image>
            <div class="homeBigText">
<!--              {{ $t("home.home21") }}-->
              <div v-if="result.rows.length>3">
                <span v-if="lan=='zh'" > {{result.rows[1].title}}</span>
                <span v-else>{{result.rows[1].titleEn}}</span>
              </div>
              <div v-else>
                {{ $t("home.home21") }}
              </div>
            </div>
            <div class="homeNormalText">
              <span v-if="result.rows.length>3">
                <p v-if="lan=='zh'" v-html="result.rows[1].content" ></p>
                <p v-else  v-html="result.rows[1].contentEn"> </p>
              </span>
              <p v-else>
                {{ $t("home.home22") }}
              </p>
            </div>
            <!--            <el-link class="homeMoreText" type="danger">{{ $t("home.homeMore") }}</el-link>-->
          </div>

        </el-col>
      </el-row>
      <el-row class="myrow">
        <el-col :span="9" :offset="3">
          <div style="margin-right: 3vw">
            <el-image :src="require('@/assets/img/mo_01.png')"
                      style="margin-bottom:2vh;background-color:white;padding:5px;height: 5vw"></el-image>
            <div class="homeBigText">
<!--              {{ $t("home.home31") }}-->
              <div v-if="result.rows.length>3">
                <span v-if="lan=='zh'" > {{result.rows[2].title}}</span>
                <span v-else>{{result.rows[2].titleEn}}</span>
              </div>
              <div v-else>
                {{ $t("home.home31") }}
              </div>
            </div>
            <div class="homeNormalText">
               <span v-if="result.rows.length>3">
                <p v-if="lan=='zh'" v-html="result.rows[2].content" ></p>
                <p v-else  v-html="result.rows[2].contentEn"> </p>
              </span>
              <p v-else>
                {{ $t("home.home32") }}
              </p>
            </div>
            <!--            <el-link class="homeMoreText" type="danger">{{ $t("home.homeMore") }}</el-link>-->
          </div>
        </el-col>
        <el-col :span="9">
          <div  v-if="result.rows.length>3" >
            <el-image class="homeImage" :src="imgWeb+result.rows[2].url" :fit="imgFit"></el-image>
          </div>
          <div v-else>
            <el-image class="homeImage" :src="require('@/assets/img/home3.jpg')" :fit="imgFit"></el-image>

          </div>
        </el-col>
      </el-row>
      <el-row class="myrow">
        <el-col :span="9" :offset="3">

          <div  v-if="result.rows.length>3" >
            <el-image class="homeImage" :src="imgWeb+result.rows[3].url" :fit="imgFit"></el-image>
          </div>
          <div v-else>
            <el-image class="homeImage" :src="require('@/assets/img/home4.jpg')" :fit="imgFit"></el-image>
          </div>
        </el-col>
        <el-col :span="9">
          <div style="margin-left: 3vw">
            <el-image :src="require('@/assets/img/mo_04.png')"
                      style="margin-bottom:2vh;background-color:white;padding:5px;height: 5vw"></el-image>
            <div class="homeBigText">
              <div v-if="result.rows.length>3">
                <span v-if="lan=='zh'" > {{result.rows[3].title}}</span>
                <span v-else>{{result.rows[3].titleEn}}</span>
              </div>
              <div v-else>
                {{ $t("home.home41") }}
              </div>
            </div>
            <div class="homeNormalText">

               <span v-if="result.rows.length>3">
                <p v-if="lan=='zh'" v-html="result.rows[3].content" ></p>
                <p v-else  v-html="result.rows[3].contentEn"> </p>
              </span>
              <p v-else>
                {{ $t("home.home42") }}
              </p>
            </div>
            <!--            <el-link class="homeMoreText" type="danger">{{ $t("home.homeMore") }}</el-link>-->
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="background-color: #F5F5F5;padding: 2vw;">
      <div class="homeImageHzhb">
        <el-image :src="require('@/assets/img/s3_bt.png')" :fit="imgFit"></el-image>
      </div>

      <div class="homeHZHB">
        <el-image :src="require('@/assets/img/part_01.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_02.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_03.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_04.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_05.png')" :fit="imgFit"></el-image>

        <el-image :src="require('@/assets/img/part_06.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_07.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_08.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_09.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_10.png')" :fit="imgFit"></el-image>

        <el-image :src="require('@/assets/img/part_11.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_12.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_13.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_14.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_15.png')" :fit="imgFit"></el-image>

        <el-image :src="require('@/assets/img/part_16.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_17.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_18.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_19.png')" :fit="imgFit"></el-image>
        <el-image :src="require('@/assets/img/part_20.png')" :fit="imgFit"></el-image>
      </div>

    </div>
  </div>
</template>

<script setup>
import {ref, toRef, computed, reactive, onMounted} from 'vue'
import {useI18n} from 'vue-i18n'//要在js中使用国际化
import {useStore} from 'vuex'
import {axiosGet} from "../../api/api"; // 引入useStore 方法

const {locale} = useI18n()

let infoZH = ""
let infoEN = ""
let isWeb = false
let lan = computed(() => {
  return locale.value
})
let result = reactive({rows:[]})
let imgFit = 'cover'
// const imgFit='fill'
let urls = [require('@/assets/img/banner.png'),require('@/assets/img/banner6.png'),require('@/assets/img/banner5.png'),require('@/assets/img/banner2.png'),require('@/assets/img/banner3.png')]

let imgWeb=window.api.apiURL+'prod-api';
onMounted(() => {
  getList(1)
})

function getList(currentpage) {

  console.log("当前是第几页" + currentpage + locale.value)
  // classify（1：图片，2：中文，3：英文，4：中英文）
  let classify = 4;
  // if (locale.value == 'zh') {
  //   classify = 2;
  // } else {
  //   classify = 3;
  // }
  axiosGet("/prod-api/system/result/getArticleList", {
    "type": 100,
    "classify": classify,
    'pageNum': currentpage,
    'pageSize': 10
  }).then(res => {
    result.rows = res.data.rows
    isWeb =true
    console.log(isWeb)
    // console.log(result)
  })
}

// export default {
//
//   name: "home",
//   setup() {
//
//     let imgFit = 'cover'
//     // const imgFit='fill'
//     let urls = [require('@/assets/img/banner.png')]
//     // const urls = [require('@/assets/img/banner.png'), require('@/assets/img/banner1.jpg'), require('@/assets/img/banner3.jpg')]
//     // const urls=[ 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
//     //   'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg',
//     //   'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg',]
//
//     return {urls, imgFit}
//   }
// }
</script>
<script setup>


</script>


<style scoped>

.customer-case-img {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.bannerImage {
  height: 400px;
}

.myrow {
  margin-top: 8vh;
}

.homeImage {
  width: 33vw;
  height: 20vw;
  margin-top: 15px;
  cursor: pointer;
  transition: all 0.9s;
}

.homeImage:hover {
  transform: scale(1.1);
}

.homeImageHzhb {
  margin: 0 auto;
  width: 20vw;
  margin-top: 3vh;
  margin-bottom: -3vh;
}

.homeBigText {
  color: black;
  font-weight: bold;
  font-size: 1.6rem;
  margin-bottom: 15px;
}

.homeNormalText {
  color: #333333;
  margin-bottom: 10px;
  font-size: 1.0rem;
  line-height: 2;
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;

}

.homeHZHB {
  display: grid;
  margin: 0 auto;
  padding: 5vh;
  justify-content: space-around;
  width: 75vw;
  grid-template-columns: repeat(5, 12vw);
  /*grid-template-rows: repeat(4, 5vw);*/
  grid-row-gap: 5vh;

}

.homeMoreText {
  color: #f00;
  margin-bottom: 10px;
  font-size: 1.0rem;
  font-weight: bold;
  margin-top: 1vw;
}
</style>



